export const redirectLocation = (url: string | undefined, openNewTab?: boolean): void => {
  const toUrl = url || document.referrer || process.env.API_IZI_BASE_URL || 'https://izi-by-edf.fr/'

  window.open(`${openNewTab ? 'https://izi-by-edf.fr' : ''}${toUrl}`, openNewTab ? '_blank' : '_self')
}

// Get URL Parameter of location search of react router
export const getURLParameters = (search: string, parameter: string): string | null => {
  const params = new URLSearchParams(search)

  return params.get(parameter)
}

export const getTrackingFormattedSlug = (): string | undefined => {
  const splitPathname = window.location.pathname.split('/')
  let idx = splitPathname.findIndex((e) => e === 'offre')

  if (idx === -1) {
    idx = splitPathname.findIndex((e) => e === 'parcours')
  }

  return splitPathname[idx + 1]
}

export const getHrefLastPart = (href: string): string | undefined => {
  if (!href.includes('/')) {
    return href
  }

  const hrefParts = href.split('/')

  return hrefParts[hrefParts.length - 1]
}

const getRepository = (url: string): string | undefined => url.split('/')[1]

export const getRepositoryAndPagePath = (urlHref: string): { repository: string; pagePath: string } => {
  let repository = ''
  let pagePath = ''
  const firstChar = urlHref[0]

  if (!firstChar || firstChar === '#') {
    return { repository: '', pagePath: '' }
  }
  if (firstChar === '/') {
    repository = 'home'
    pagePath = 'home'
  } else if (firstChar === 'h') {
    const url = new URL(urlHref)

    if (url.host.includes('izi-by-edf-renov')) {
      repository = 'izi_renov'
      pagePath = url.pathname.substring(1)
    } else if (url.host.includes('izi-by-edf')) {
      repository = getRepository(url.pathname) ?? ''
      pagePath = url.pathname.substring(1)
    } else {
      repository = 'externe_goto'
      pagePath = url.host
    }
  }

  return { repository, pagePath }
}
// Replace all the - by _ and / by ~ for algolia url
export const encodeURLForAlgolia = (url: string): string => url.trim().replace(/\s/g, '_').replace(/\//g, '~')

export const getFormattedReferrer = (referrer: string): string => {
  const urlPrev = new URL(referrer || window.location.href)

  return `${urlPrev.origin}${urlPrev.pathname}`
}
